export const serviceIdMap = new Map();

export const ServiceIds = {
    // Old ids
    free: "rugby-free",
    daily: "vc-fanclash-vodacom-fl-rugby-daily-01",
    weekly: "vc-fanclash-vodacom-fl-rugby-weekly-01",
    monthly: "vc-fanclash-vodacom-fl-rugby-monthly-01",

    // New ids
    dailyInternal: "vc-fanclash-quizincrugby-daily-01",
    weeklyInternal: "vc-fanclash-quizincrugby-weekly-01",
    monthlyInternal: "vc-fanclash-quizincrugby-monthly-01",

    // Rugga Nation
    ruggaNation: "RuggaNation",
}

serviceIdMap.set(ServiceIds.free, 1);
serviceIdMap.set(ServiceIds.daily, 2);
serviceIdMap.set(ServiceIds.weekly, 3);
serviceIdMap.set(ServiceIds.monthly, 4);

serviceIdMap.set(ServiceIds.dailyInternal, 2);
serviceIdMap.set(ServiceIds.weeklyInternal, 3);
serviceIdMap.set(ServiceIds.monthlyInternal, 4);

serviceIdMap.set(ServiceIds.ruggaNation, 306);
